export class OrganizationException extends Error {
}
